(function () {
  function readStampedSummary() {
    var root = document.getElementById('stamped-main-widget');
    if (!root) return null;

    var summary = root.querySelector('.stamped-summary');
    var text = (summary || root).textContent.replace(/\s+/g, ' ');
    var countMatch = text.match(/Based on\s+([\d,]+)\s+Reviews/i);
    var ratingMatch = text.match(/\b([0-5](?:\.\d)?)\s+Based on/i);

    if (!countMatch) return null;

    return {
      count: countMatch[1].replace(/,/g, ''),
      rating: ratingMatch && ratingMatch[1] ? ratingMatch[1] : '',
    };
  }

  function syncStampedRating() {
    var summary = readStampedSummary();
    if (!summary) return false;

    document.querySelectorAll('[data-stamped-rating-count]').forEach(function (node) {
      var count = Number(summary.count);
      node.textContent = summary.count + ' Review' + (count === 1 ? '' : 's');
    });

    if (summary.rating) {
      document.querySelectorAll('[data-stamped-rating-value]').forEach(function (node) {
        node.textContent = Number(summary.rating).toFixed(1);
      });
    }

    return true;
  }

  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    syncStampedRating();
    if (attempts > 80) window.clearInterval(timer);
  }, 250);

  document.addEventListener('stamped:reviews:loaded', syncStampedRating);

  window.setTimeout(function () {
    var root = document.getElementById('stamped-main-widget');
    if (!root || !('MutationObserver' in window)) return;

    var observer = new MutationObserver(syncStampedRating);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    syncStampedRating();
  }, 1000);
})();
